import { render } from "./QuickpayPaymentHeader.vue?vue&type=template&id=c27723ca&scoped=true"
import script from "./QuickpayPaymentHeader.vue?vue&type=script&lang=js"
export * from "./QuickpayPaymentHeader.vue?vue&type=script&lang=js"

import "./QuickpayPaymentHeader.vue?vue&type=style&index=0&id=c27723ca&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c27723ca"]])

export default __exports__